import { render, staticRenderFns } from "./TestDropdown.vue?vue&type=template&id=fc8f1bba&scoped=true&"
import script from "./TestDropdown.vue?vue&type=script&lang=js&"
export * from "./TestDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TestDropdown.vue?vue&type=style&index=0&id=fc8f1bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8f1bba",
  null
  
)

export default component.exports